import { render, staticRenderFns } from "./ActivityLayout.vue?vue&type=template&id=0fc0ea89&scoped=true"
import script from "./ActivityLayout.vue?vue&type=script&lang=ts"
export * from "./ActivityLayout.vue?vue&type=script&lang=ts"
import style0 from "./ActivityLayout.vue?vue&type=style&index=0&id=0fc0ea89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc0ea89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
